module.exports = __webpack_public_path__ + "img/Feature.08519437.png";